<div class="modal-header">
  <h4 class="modal-title d-block">Transfer of keepership request</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onCloseModal()">
  </button>
</div>
